import { RoutesEnum } from '@ui-core/enums/routes.enum'

const DASHBOARD_URL = 'dashboard'
const DASHBOARD_VALID_ROUTES = ['/', '', 'dashboard']
const EMAIL_SUPPORT = 'support@cucumber.co.nz'
const OPEN_ROUTES = [RoutesEnum.FORBIDDEN, RoutesEnum.ERROR_TENANT, RoutesEnum.ERROR_CONFIGURATION]
const TENANT_DEFAULT = 'cucumber'

const APP_CONFIG = {
    rowsPerPage: 10,
    rowsPerPageOptions: [0, 10, 20, 50, 100],
    leavingMessage: {
        messageFull:
            'You are about to leave the form without saving your changes, proceeding with this action will cause all changes to be lost.',
        messageShort: 'Proceeding with this action will cause all changes to be lost.',
        header: 'Unsaved changes'
    }
}

const ERRORS = {
    [RoutesEnum.FORBIDDEN]: {
        title: 'Forbidden - 403',
        message: 'You do not have permission to access this resource..'
    },
    [RoutesEnum.ERROR_TENANT]: {
        title: 'Tenant Error',
        message: 'The requested tenant does not exist or is not configured correctly.'
    },
    [RoutesEnum.ERROR_CONFIGURATION]: {
        title: 'Configuration Error',
        message: 'There was an error fetching the configuration.'
    },
    tenantFullPage: {
        title: 'Tenant Error',
        message: 'Error loading tenant profile for organizationAlias: {PLACEHOLDER}.'
    },
    [RoutesEnum.ERROR_404]: {
        title: 'Page Not Found - 404',
        message: 'The page you are looking for does not exist.'
    }
}

const TOKEN_KEYS = {
    organisation: 'organization',
    preferred_username: 'preferred_username',
    given_name: 'given_name',
    family_name: 'family_name'
}

const BG_COLOUR = '#f9fafb'

export {
    APP_CONFIG,
    BG_COLOUR,
    DASHBOARD_URL,
    DASHBOARD_VALID_ROUTES,
    EMAIL_SUPPORT,
    ERRORS,
    OPEN_ROUTES,
    TENANT_DEFAULT,
    TOKEN_KEYS
}
